import { render, staticRenderFns } from "./ManageTemplates.vue?vue&type=template&id=9e93fec0&scoped=true"
import script from "./ManageTemplates.vue?vue&type=script&lang=js"
export * from "./ManageTemplates.vue?vue&type=script&lang=js"
import style0 from "./ManageTemplates.vue?vue&type=style&index=0&id=9e93fec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93fec0",
  null
  
)

export default component.exports